import { Select } from 'antd';
import styled from 'styled-components';
import { customerFilterTag } from './customerFilterConstant';

type Props = {
  value?: string[];
  onChange?: (value: string[]) => void;
};

const SelectTagsInput = ({ value, onChange }: Props) => {
  return (
    <StyledSelect
      placeholder='Select Tags by Filter button'
      size='large'
      open={false}
      mode='multiple'
      options={customerFilterTag}
      suffixIcon={null}
      value={value}
      onChange={(value) => onChange?.(value as string[])}
      style={{ width: '100%' }}
    />
  );
};

export default SelectTagsInput;

const StyledSelect = styled(Select)`
  .ant-select-selection-item-remove {
    color: red !important;
  }
`;
